export const NumberUtil = {
    formatPrice(raw: number | null): string | null {
        if (raw === null) {
          return null;
        }
        const priceFormatter = Intl.NumberFormat('en-us',{style: 'currency', currency: 'USD'})
        return priceFormatter.format(raw);
      }
}